import { truncateLongFileNames } from "..";
import config from "../../../../../../application/config/config";
import "./styles.css";

export function Message({ message, isCurrentUser }) {

    return (
        <div className={`direct-chat-msg max-w ${!isCurrentUser ? 'right' : ''}`} key={message.id} style={{ width: 'fit-content' }}>
            <div className="direct-chat-infos clearfix" style={isCurrentUser ? { marginLeft: "3rem" } : undefined}>
                <span className={`direct-chat-timestamp float-left`}>{message.date_time}</span>
            </div>
            {message.photo ? <img className="direct-chat-img" src={`${!message.photo.includes('http') ? config.endpoints.backend : ''}${message.photo}`} alt="Message User" /> : <i className="direct-chat-img profile fa-regular fa-user"></i>}
            <div className="direct-chat-text">
                {isCurrentUser && (
                    <>
                        <span className={`direct-chat-name float-left`}>{message.user_name}</span>
                        <br />
                    </>
                )}
                {message.message}
                <div className="files">
                    {message.files != [] && message.files.map((file) => (
                        <>
                            <a href={file.files3} key={file.files3} className={`file ${isCurrentUser ? 'contrast' : ''}`}>
                                {truncateLongFileNames(file.filename)}
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M5.83333 8.33333L10 12.5M10 12.5L14.1667 8.33333M10 12.5V2.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </a>
                        </>
                    ))}
                </div>
            </div>
        </div>
    );
}